import {
  PROJECT_PERMISSIONS,
  CAMERA_PERMISSIONS,
} from "@evercam/dashboard/constants/permissions"

export const PROJECT_ROLES = {
  project_admin: {
    text: "Project Admin",
    value: "project_admin",
    cameraAccessLevel: "full_access",
    permissions: [
      ...Object.values(PROJECT_PERMISSIONS.DRONE_VIEW),
      ...Object.values(PROJECT_PERMISSIONS.VIEW_360),
      ...Object.values(PROJECT_PERMISSIONS.BIM_VIEW),
      ...Object.values(PROJECT_PERMISSIONS.GATE_REPORT),
      ...Object.values(PROJECT_PERMISSIONS.WEATHER),
      ...Object.values(PROJECT_PERMISSIONS.VIDEO_WALL),
      ...Object.values(PROJECT_PERMISSIONS.SITE_PLANNER),
      ...Object.values(PROJECT_PERMISSIONS.TIMELINE),
      ...Object.values(PROJECT_PERMISSIONS.AUTOMATIONS),
      ...Object.values(PROJECT_PERMISSIONS.MEDIA_HUB),
      ...Object.values(PROJECT_PERMISSIONS.COMMENTS),
      ...Object.values(PROJECT_PERMISSIONS.SETTINGS),
    ],
  },
  project_member: {
    text: "Project Member",
    value: "project_member",
    cameraAccessLevel: "full_access",
    permissions: [
      ...Object.values(PROJECT_PERMISSIONS.DRONE_VIEW).filter(
        (p) => p !== PROJECT_PERMISSIONS.DRONE_VIEW.SETTINGS
      ),
      ...Object.values(PROJECT_PERMISSIONS.VIEW_360).filter(
        (p) => p !== PROJECT_PERMISSIONS.VIEW_360.SETTINGS
      ),
      ...Object.values(PROJECT_PERMISSIONS.BIM_VIEW).filter(
        (p) => p !== PROJECT_PERMISSIONS.BIM_VIEW.SETTINGS
      ),
      ...Object.values(PROJECT_PERMISSIONS.GATE_REPORT),
      ...Object.values(PROJECT_PERMISSIONS.WEATHER),
      ...Object.values(PROJECT_PERMISSIONS.VIDEO_WALL),
      ...Object.values(PROJECT_PERMISSIONS.SITE_PLANNER),
      ...Object.values(PROJECT_PERMISSIONS.TIMELINE),
      ...Object.values(PROJECT_PERMISSIONS.AUTOMATIONS),
      ...Object.values(PROJECT_PERMISSIONS.MEDIA_HUB),
      ...Object.values(PROJECT_PERMISSIONS.COMMENTS),
      PROJECT_PERMISSIONS.SETTINGS.VIEW,
    ],
  },
  collaborator: {
    text: "Collaborator",
    value: "collaborator",
    cameraAccessLevel: "view_only",
    permissions: [
      PROJECT_PERMISSIONS.DRONE_VIEW.VIEW,
      PROJECT_PERMISSIONS.VIEW_360.VIEW,
      PROJECT_PERMISSIONS.BIM_VIEW.VIEW,
      ...Object.values(PROJECT_PERMISSIONS.GATE_REPORT),
      ...Object.values(PROJECT_PERMISSIONS.WEATHER),
      PROJECT_PERMISSIONS.VIDEO_WALL.VIEW,
      PROJECT_PERMISSIONS.SITE_PLANNER.VIEW,
      PROJECT_PERMISSIONS.TIMELINE.VIEW,
      PROJECT_PERMISSIONS.MEDIA_HUB.VIEW,
      PROJECT_PERMISSIONS.COMMENTS.VIEW,
      PROJECT_PERMISSIONS.COMMENTS.CREATE,
    ],
  },
}

export const CAMERA_ROLES = {
  no_access: {
    text: "No Access",
    value: "no_access",
    width: 120,
    permissions: [],
  },
  full_access: {
    text: "Full Access",
    value: "full_access",
    width: 120,
    permissions: [
      CAMERA_PERMISSIONS.LIVE_VIEW.VIEW,
      CAMERA_PERMISSIONS.RECORDINGS.VIEW,
      CAMERA_PERMISSIONS.RECORDINGS.EXPORT_CLIP,
      CAMERA_PERMISSIONS.EDIT_TOOL.EDIT_IMAGES,
      CAMERA_PERMISSIONS.EDIT_TOOL.DOWNLOAD_IMAGES,
      CAMERA_PERMISSIONS.EDIT_TOOL.SAVE_IMAGES,
      CAMERA_PERMISSIONS.EDIT_TOOL.SEND_IMAGES,
      CAMERA_PERMISSIONS.COMPARE.VIEW,
      CAMERA_PERMISSIONS.COMPARE.EXPORT_GIF,
      CAMERA_PERMISSIONS.PTZ.LIVE_VIEW,
      CAMERA_PERMISSIONS.PTZ.MOVE,
      CAMERA_PERMISSIONS.PTZ.RESET_POSITION,
      CAMERA_PERMISSIONS.PTZ.SET_HOME_POSITION,
      CAMERA_PERMISSIONS.PTZ.ADD_PRESET,
      CAMERA_PERMISSIONS.PTZ.VIEW_PRESETS,
      CAMERA_PERMISSIONS.PTZ.DELETE_PRESETS,
      CAMERA_PERMISSIONS.PTZ.EDIT_PRESET,
      CAMERA_PERMISSIONS.TIME_LAPSE.CREATE,
    ],
  },
  view_only: {
    text: "View Only",
    value: "view_only",
    width: 120,
    permissions: [
      CAMERA_PERMISSIONS.LIVE_VIEW.VIEW,
      CAMERA_PERMISSIONS.COMPARE.VIEW,
      CAMERA_PERMISSIONS.PTZ.LIVE_VIEW,
      CAMERA_PERMISSIONS.PTZ.VIEW_PRESETS,
    ],
  },
}
